import controller from './http-error.controller.js';
import template from './http-error.html';

let httpErrorModule = angular.module('http-error', [])

    .directive('httpError', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            bindToController: true,
            template: template
        };
    })

    .name;

export default httpErrorModule;



// WEBPACK FOOTER //
// ./src/app/angular/http-error/http-error.js